import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

// https://mui.com/components/icons/#createsvgicon
import { jsx as _jsx } from "react/jsx-runtime";
export var OpenNotifications = createSvgIcon( /*#__PURE__*/_jsx("svg", {
  fill: "none",
  height: "21",
  viewBox: "0 0 24 21",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M21.6038 0.64035H3.00237C1.86562 0.64035 0.935547 1.54035 0.935547 2.64035V14.6404C0.935547 15.7404 1.86562 16.6404 3.00237 16.6404H10.2363V18.6404H8.16944V20.6404H16.4367V18.6404H14.3699V16.6404H21.6038C22.7406 16.6404 23.6706 15.7404 23.6706 14.6404V2.64035C23.6706 1.54035 22.7406 0.64035 21.6038 0.64035ZM21.6038 14.6404H3.00237V2.64035H21.6038V14.6404Z",
    fill: "#6B6B6B"
  })
}), 'OpenNotifications');